<template>
  <div class="wrap">
    <div v-if="isSysCode">
      <div class="top">
        <div class="topcontent">
          <div class="welcome" v-if="webLoginUser">
            欢迎{{ webLoginUser.comfullname
            }}<span v-if="webLoginUser.username !== webLoginUser.comfullname">-{{ webLoginUser.username }}</span>使用{{
    cos.cosname
}}
          </div>
          <div class="welcome" v-else>欢迎您使用{{ cos.cosname }}</div>
          <div class="mobile-nav" @click="showMobileNav" v-if="
            $route.name != 'login' &&
            $route.name != 'reg' &&
            $route.name != 'forgotpwd' &&
            $route.name != 'BidToday'
          ">
            <i class="el-icon-s-operation" v-if="!this.$store.state.shownav"></i>
            <i class="el-icon-close" v-else></i>
          </div>
          <div class="operate">
            <span @click="$router.push({ path: '/expertLogin' })">项目评审</span>
            | <span @click="setHome()">设为首页</span> |
            <span @click="join">加入收藏</span><span v-if="$route.path !== '/'">
              | <span @click="returnIndex">返回首页</span></span>
          </div>
        </div>
      </div>
      <div>
        <web-header v-if="isSysCode"></web-header>
      </div>
      <div class="content">
        <router-view v-if="isMain"></router-view>
        <web-footer v-if="isSysCode"></web-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WebHeader from "./layout/Header";
import WebFooter from "./layout/Footer";
import config from "@/config";
import request from "./utils/request";
export default {
  name: "app",
  data() {
    return {
      isSysCode: false,
      isMain: false,
    };
  },
  components: { WebHeader, WebFooter },
  // created () {
  //   window.addEventListener("beforeunload", () => {
  //     window.localStorage.setItem("obweb_state", JSON.stringify(this.$store.state))
  //     // this.$store.state = Object.assign(this.$store.state, JSON.parse(window.localStorage.getItem("obweb_state")))
  //     })
  // },
  mounted() {
    document.title = config.title;
  },
  async created() {
    const coscode = config.platformCode;
    let res = await request({
      method: "get",
      url: "/ywgl/cos/getCosByCode",
      params: { coscode },
    });
    this.$store.commit("changeState", { cosId: res[0].cosid });
    this.$store.commit("changeState", { cos: res[0] });
    this.isSysCode = true;
    setTimeout(() => {
      this.isMain = true;
    }, 300);
  },
  methods: {
    returnIndex() {
      this.$router.replace({ path: "/" });
    },
    setHome() {
      //设置首页
    },
    join() {
      let sTitle = "1111111111";
      try {
        window.external.addFavorite(window.location, sTitle);
      } catch (e) {
        try {
          window.sidebar.addPanel(sTitle, window.location, "");
        } catch (e) {
          alert("加入收藏失败,请使用Ctrl+D进行添加,或手动在浏览器里进行设置.");
        }
      }
    },
    showMobileNav() {
      this.$store.state.shownav = !this.$store.state.shownav;
    },
  },
  computed: {
    ...mapGetters([
      "webLoginUser",
      "menus",
      "parentActiveTab",
      "childActiveTab",
      "cos",
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "./styles/variables.scss";

@media screen and (min-width: 1201px) {
  .wrap {
    font-family: Microsoft YaHei;
    color: $color-black;
    font-size: $fontsize-medium;
    display: flex;
    flex-direction: column;

    /*height: 100vh;*/
    /*overflow-y: hidden;*/
    .top {
      display: flex;
      justify-content: center;
      background-color: $color-blue;

      .topcontent {
        width: 100%;
        line-height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: $fontsize-medium-s;
        color: $color-greyish-white;

        span {
          cursor: pointer;
        }

        .mobile-nav {
          display: none;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      /*overflow-y: scroll;*/
      background-color: $color-bg-gray;
    }
  }
}

@media screen and (max-width: 1200px) {
  .wrap {
    .top {
      .topcontent {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        width: 100%;
        height: 50px;
        background-color: #000;
        color: #fff;
        z-index: 9;

        .operate {
          display: none;
        }

        .mobile-nav {
          i {
            font-size: 25px;
          }
        }
      }
    }
  }
}
</style>
